
import { useState } from 'react';

const comarcas = [
  {
    name: 'Barcelonès',
    icon: 'ri-building-line',
    color: '#ff6b35',
    cities: [
      { name: 'Barcelona Ciudad', slug: '/desguace-barcelona-ciudad', population: '1.636.000' },
      { name: 'Badalona', slug: '/desguace-badalona', population: '223.000' },
      { name: "L'Hospitalet", slug: '/desguace-hospitalet', population: '264.000' },
      { name: 'Santa Coloma de Gramenet', slug: '/desguace-santa-coloma', population: '119.000' },
      { name: 'Sant Adrià de Besòs', slug: '/desguace-sant-adria', population: '37.000' },
      { name: 'Montgat', slug: '/desguace-montgat', population: '12.000' },
    ],
  },
  {
    name: 'Vallès Occidental',
    icon: 'ri-landscape-line',
    color: '#e85d2a',
    cities: [
      { name: 'Sabadell', slug: '/desguace-sabadell', population: '216.000' },
      { name: 'Terrassa', slug: '/desguace-terrassa', population: '224.000' },
      { name: 'Sant Cugat del Vallès', slug: '/desguace-sant-cugat', population: '94.000' },
      { name: 'Rubí', slug: '/desguace-rubi', population: '78.000' },
      { name: 'Cerdanyola del Vallès', slug: '/desguace-cerdanyola', population: '58.000' },
      { name: 'Barberà del Vallès', slug: '/desguace-barbera', population: '33.000' },
      { name: 'Ripollet', slug: '/desguace-ripollet', population: '39.000' },
      { name: 'Montcada i Reixac', slug: '/desguace-montcada', population: '36.000' },
      { name: 'Castellbisbal', slug: '/desguace-castellbisbal', population: '12.000' },
    ],
  },
  {
    name: 'Baix Llobregat',
    icon: 'ri-road-map-line',
    color: '#d4501f',
    cities: [
      { name: 'Cornellà de Llobregat', slug: '/desguace-cornella', population: '89.000' },
      { name: 'Esplugues de Llobregat', slug: '/desguace-esplugues', population: '46.000' },
      { name: 'Gavà', slug: '/desguace-gava', population: '47.000' },
      { name: 'Sant Boi de Llobregat', slug: '/desguace-sant-boi', population: '84.000' },
      { name: 'El Prat de Llobregat', slug: '/desguace-el-prat', population: '64.000' },
      { name: 'Viladecans', slug: '/desguace-viladecans', population: '67.000' },
      { name: 'Castelldefels', slug: '/desguace-castelldefels', population: '67.000' },
      { name: 'Martorell', slug: '/desguace-martorell', population: '28.000' },
      { name: 'Sant Andreu de la Barca', slug: '/desguace-sant-andreu-barca', population: '28.000' },
    ],
  },
  {
    name: 'Vallès Oriental',
    icon: 'ri-plant-line',
    color: '#c44518',
    cities: [
      { name: 'Granollers', slug: '/desguace-granollers', population: '62.000' },
      { name: 'Mollet del Vallès', slug: '/desguace-mollet', population: '52.000' },
    ],
  },
  {
    name: 'Maresme',
    icon: 'ri-sailboat-line',
    color: '#b33d12',
    cities: [
      { name: 'Mataró', slug: '/desguace-mataro', population: '129.000' },
      { name: 'Premià de Mar', slug: '/desguace-premia-de-mar', population: '28.000' },
      { name: 'Vilassar de Mar', slug: '/desguace-vilassar-de-mar', population: '21.000' },
    ],
  },
  {
    name: 'Alt Penedès',
    icon: 'ri-goblet-line',
    color: '#a3360e',
    cities: [
      { name: 'Vilafranca del Penedès', slug: '/desguace-vilafranca', population: '40.000' },
    ],
  },
  {
    name: 'Anoia / Bages',
    icon: 'ri-mountain-line',
    color: '#932f0a',
    cities: [
      { name: 'Igualada', slug: '/desguace-igualada', population: '40.000' },
      { name: 'Manresa', slug: '/desguace-manresa', population: '78.000' },
    ],
  },
];

export default function ZoneMap() {
  const [activeComarca, setActiveComarca] = useState<string | null>(null);

  const totalCities = comarcas.reduce((acc, c) => acc + c.cities.length, 0);

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-3xl font-bold text-[#ff6b35]">{totalCities}</p>
            <p className="text-sm text-gray-600 mt-1">Ciudades cubiertas</p>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-3xl font-bold text-[#ff6b35]">7</p>
            <p className="text-sm text-gray-600 mt-1">Comarcas</p>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-3xl font-bold text-[#ff6b35]">3M+</p>
            <p className="text-sm text-gray-600 mt-1">Habitantes cubiertos</p>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center">
            <p className="text-3xl font-bold text-[#ff6b35]">24h</p>
            <p className="text-sm text-gray-600 mt-1">Recogida máxima</p>
          </div>
        </div>

        {/* Map + Sidebar */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Sidebar comarcas */}
          <div className="lg:col-span-2 space-y-3">
            <h2 className="text-2xl font-bold text-[#1a2332] mb-6">
              <i className="ri-compass-3-line mr-2 text-[#ff6b35]"></i>
              Comarcas
            </h2>
            {comarcas.map((comarca) => (
              <button
                key={comarca.name}
                onClick={() => setActiveComarca(activeComarca === comarca.name ? null : comarca.name)}
                className={`w-full text-left rounded-xl border transition-all cursor-pointer ${
                  activeComarca === comarca.name
                    ? 'bg-[#ff6b35]/5 border-[#ff6b35] shadow-md'
                    : 'bg-white border-gray-100 hover:border-[#ff6b35]/40 hover:shadow-sm'
                }`}
              >
                <div className="flex items-center justify-between p-4">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${comarca.color}15` }}
                    >
                      <i className={`${comarca.icon} text-xl`} style={{ color: comarca.color }}></i>
                    </div>
                    <div>
                      <p className="font-semibold text-[#1a2332] text-sm">{comarca.name}</p>
                      <p className="text-xs text-gray-500">{comarca.cities.length} ciudades</p>
                    </div>
                  </div>
                  <i
                    className={`ri-arrow-down-s-line text-gray-400 transition-transform ${
                      activeComarca === comarca.name ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
                {activeComarca === comarca.name && (
                  <div className="px-4 pb-4 pt-1 border-t border-gray-100">
                    <ul className="space-y-2">
                      {comarca.cities.map((city) => (
                        <li key={city.slug}>
                          <a
                            href={city.slug}
                            className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-[#ff6b35]/5 transition-colors cursor-pointer group"
                          >
                            <span className="text-sm text-gray-700 group-hover:text-[#ff6b35] transition-colors">
                              {city.name}
                            </span>
                            <span className="text-xs text-gray-400">{city.population} hab.</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </button>
            ))}
          </div>

          {/* Google Map */}
          <div className="lg:col-span-3">
            <h2 className="text-2xl font-bold text-[#1a2332] mb-6">
              <i className="ri-map-2-line mr-2 text-[#ff6b35]"></i>
              Mapa de Cobertura
            </h2>
            <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-100" style={{ height: '620px' }}>
              <iframe
                title="Mapa de cobertura Desguace Barcelona"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d190028.47044842!2d2.0!3d41.42!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2ses!4v1700000000000!5m2!1ses!2ses"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <p className="text-xs text-gray-400 mt-3 text-center">
              Cubrimos toda la provincia de Barcelona y alrededores
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
